export default "__VITE_ASSET__DmI_OAXP__"